export default "__VITE_ASSET__e4186ad8__"